export const comprovanteoOption = [
  { label: 'Todos', value: 'ALL' },
  { label: 'Enviados', value: 'S' },
  { label: 'Não enviados', value: 'N' },
];
